/* RESPONSIBLE TEAM: team-messenger */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type MessengerSettingsService from 'embercom/services/messenger-settings-service';
import type MessengerSettingsTargetUserProvider from 'embercom/services/messenger-settings-target-user-provider';
import type Transition from '@ember/routing/transition';
import { DEFAULT_SECTIONS_FOR_TABS, type Tab } from 'embercom/services/messenger-settings-service';
import type Router from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';

export default class MessengerConversationsRoute extends IntercomRoute {
  @service declare MessengerSettingsService: MessengerSettingsService;
  @service declare messengerSettingsTargetUserProvider: MessengerSettingsTargetUserProvider;
  @service declare router: Router;
  @service declare appService: { app: { canUseStandalone: boolean } };
  @service declare intl: IntlService;

  queryParams = {
    tab: {
      refreshModel: false,
      replace: true,
    },
    section: {
      refreshModel: false,
      replace: true,
    },
  };

  get titleToken() {
    return this.intl.t(`new-settings.submenu.channels.messenger`);
  }

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-messenger',
    };
  }

  beforeModel() {
    if (
      !this.messengerSettingsTargetUserProvider.isUserType &&
      !this.messengerSettingsTargetUserProvider.isVisitor
    ) {
      this.messengerSettingsTargetUserProvider.setVisitorTarget();
    }
    this.MessengerSettingsService.preview.onPlatformChange('web');
  }

  afterModel(model: any, transition: Transition) {
    if (model.settings.lookAndFeel.activeBrand === model.settings.lookAndFeel.mobileBrand) {
      model.settings.lookAndFeel.activeBrand = model.settings.lookAndFeel.defaultBrand;
    }

    let { tab, section } = transition.to.queryParams;
    tab ||= this.appService.app.canUseStandalone ? 'fin' : 'teammates';
    section ||= DEFAULT_SECTIONS_FOR_TABS[tab as Tab];
    this.MessengerSettingsService.navigate(tab as Tab, section, { changeUrl: false });
  }
}
